import {
  REPORT_CHANGE_SEARCH, REPORT_CHANGE_SEARCH_SUCCESS, REPORT_CHANGE_SEARCH_FAILURE
} from './mutation-types'

export default {
  state: {
    reportChange: null,
    reportChangeCurrentPage: 1,
    reportChangeNextPage: null,
    patient: null
  },
  getters: {
    reportChange: state => {
      return state.reportChange
    },
    reportChangeCurrentPage: state => {
      return state.reportChangeCurrentPage
    },
    reportChangeNextPage: state => {
      return state.reportChangeNextPage
    }
  },
  actions: {
    [REPORT_CHANGE_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/patients/' + params.patientId + '/reports/changes'
      var data = {}
      if (params) {
        if (params.url && !params.clear) {
          url = params.url
        }
        if (params.clear) {
          state.reportChange = null
          state.reportChangeCurrentPage = 1
          state.reportChangeNextPage = null
        }
        data = params.data
      }

      dispatch('apiGet', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REPORT_CHANGE_SEARCH_FAILURE, res.data)
          } else {
            commit(REPORT_CHANGE_SEARCH_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [REPORT_CHANGE_SEARCH_FAILURE] (state, data) {
      console.log('REPORT_CHANGE_SEARCH_FAILURE')
    },
    [REPORT_CHANGE_SEARCH_SUCCESS] (state, data) {
      console.log('REPORT_CHANGE_SEARCH_SUCCESS')
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.reportChange = state.reportChange.concat(data.data)
        state.reportChangeCurrentPage = data.meta['current-page']
      } else {
        state.reportChange = data.data
        state.reportChangeCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.reportChangeNextPage = data.links['next']
      } else {
        state.reportChangeNextPage = null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/report-change.js